import { connect } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react'

import { getAnalytics, logEvent } from "firebase/analytics";

import EntityInfo from '../components/EntityInfo';

import BottomMenu from '../components/BottomMenu';
import { buildMissingRoute } from '../utils/missingRoute';

const Speaker = () => {

    let params = useParams();
    const location = useLocation();
    const analytics = getAnalytics();
    const missingRoute = buildMissingRoute(location);

    useEffect(() => {
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'speaker'
        });
    }, [analytics]);

    const missingSpeaker = (
        <Navigate to={missingRoute} replace />
    )

    return (
        <div>
            <div className="container appScreen" style={{ overflow: 'visible' }}>
                <div className='hasBottomMenu'>
                    <EntityInfo speakerId={params.speakerId} missingSpeaker={missingSpeaker} />

                    <BottomMenu />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(Speaker);
